/**
 *
 * Asynchronously loads the component for Matching
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
